import React from 'react';
import {Header, Dropdown} from 'semantic-ui-react';
import PropTypes from 'prop-types';
import {useMutation} from '@apollo/client';

import {hideModal, showModal} from '@utils/modal';
import {EVENT} from '@constants/resources';
import {SECURITY_PRIVILEGES_UPDATE} from '@constants/variables';
import {Authorization} from '@appComponents/Authorization';
import {triggerSmpSync} from '@graphql/smpSync/mutation';
import {showMessageBox} from '@utils/messageBox';

const authorizationEventUpdateObject = {
    [EVENT]: SECURITY_PRIVILEGES_UPDATE,
};

const TriggerSMPSyncButton = ({event}) => {
    const [triggerSync] = useMutation(triggerSmpSync, {
        variables: {
            eventId: event.id,
            matchId: event.sr_event.match.id,
        },
        onCompleted: () => {
            hideModal();
            showMessageBox(
                'event',
                'The sync with Scout Management Platform (SMP) has been triggered successfully for this event.',
                null,
                'success',
                false,
                true
            );
        },
        onError: () => {
            hideModal();
            showMessageBox(
                'event',
                'The sync with Scout Management Platform (SMP) could not be triggered.',
                null,
                'error',
                true,
                true
            );
        },
    });

    return (
        <Authorization authorization={authorizationEventUpdateObject}>
            <Dropdown.Item
                className='trigger-smpsync-button__dropdown-item--pointer-events-all'
                icon='bolt'
                key='smpsync'
                text='Trigger the sync with Scout Management Platform (SMP)'
                onClick={()=>showModal({
                    isVisible: true,
                    hideButtons: false,
                    content: null,
                    header: <Header content='Trigger the sync with Scout Management Platform (SMP)'/>,
                    text: 'Are you sure you want to trigger the sync with Scout Management Platform (SMP) for this event?',
                    onYes: triggerSync,
                })}
            />
        </Authorization>
    );
};

TriggerSMPSyncButton.propTypes = {
    event: PropTypes.object.isRequired,
};

export default TriggerSMPSyncButton;
